<template>
  <div>
    <a :href="adminLink" class="registerLink" @click="$track.conversion">{{
      text
    }}</a>
  </div>
</template>
<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss"  scoped>
div {
  display: flex;
  justify-content: center;
  padding: 0px 20px;
  box-sizing: border-box;
}
a.registerLink {
  all: unset;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 500px;
  max-width: 100%;
  margin: 50px auto;
  @include titleFontSize;
  font-weight: 500;
  min-height: 95px;
  background-color: $volt;
  text-align: center;
  border-radius: 6px;
  padding: 20px 20px;

  box-sizing: border-box;

  &:hover {
    background-color: $voltHover;
  }
}

@media screen and (max-width: $breakpoint) {
  a.registerLink {
    font-size: 30px;
  }
}
</style>
